import { useIsWorkInSessionEnabled } from '@/features/flags';
import { useAutoSelectRecentSessionChat } from '@/hooks/useAutoSelectRecentSessionChat';

/**
 * The session's remembered Evidence chat. With Work in session the panel opens
 * on Work home, so the most recent Evidence chat is never auto-selected. Call
 * it at the shell level (it must run while the panel is closed) and pass the
 * result to `SessionAskHeidiPane`.
 */
export const useSessionAskHeidiChatId = (sessionId: string | undefined) =>
  useAutoSelectRecentSessionChat(sessionId, !useIsWorkInSessionEnabled());
